import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../../auth/Auth';
import { HiLogout } from '@react-icons/all-files/hi/HiLogout';
import SideBarAcceptedChallenges from '../../common/SideBarAcceptedChallenges';
import TribeDependentChat from '../../chat/TribeDependentChat';
import TribeChat from '../../chat/TribeChat';
import { BsLockFill } from '@react-icons/all-files/bs/BsLockFill';
import { Spinner } from 'react-bootstrap';
import { isMobile } from 'react-device-detect';

const MyRoomRightSideBar = (props) => {
    const [width, setWidth] = useState(window.innerWidth);
    const { dependent, guardian, partner, school } = useAuth();
    const [showLayout, setShowLayout] = useState(dependent?.profile?.group?.id ? true : school ? true : false);
    const [challenge, setChallenge] = useState({});
    const [loading, setLoading] = useState(true);
    const [mobileDisplay, setMobileDisplay] = useState('');
    const [collapseClass, setCollapseClass] = useState(isMobile ? '' : showLayout ? '' : 'collapsse');
    const location = useLocation();
    // console.log(showLayout)

    const setCollapsse = () => {
        if (showLayout) {
            props.setRightCollapsse("right-collapsse");
            setCollapseClass('collapsse')
        }
        else {
            props.setRightCollapsse("");
            setCollapseClass('')
        }
        setShowLayout(!showLayout)
    }
    const handleWindowSizeChange = () => {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, [width]);
    useEffect(() => {
        if (props.selectedTreehouse) {
            setLoading(true);
            let data = {
                agora_group_id: props.selectedTreehouse[0]?.agora_group_id,
                agora_chat_box: props.selectedTreehouse[0]?.agora_chat_box,
                created_by: {
                    id: props.selectedTreehouse[0]?.id,
                    first_name: props.selectedTreehouse[0]?.group_captain?.first_name,
                    last_name: props.selectedTreehouse[0]?.group_captain?.last_name,
                    picture_url: props.selectedTreehouse[0]?.group_captain?.picture_url ? props.selectedTreehouse[0]?.group_captain?.picture_url : school?.picture_url
                },
                treehouse_id: props.selectedTreehouse[0]?.id,
                isCaptain: true,
                name: props.selectedTreehouse[0]?.name,
                day: props.selectedTreehouse[0]?.day,
                time: props.selectedTreehouse[0]?.time,
                timezone: props.selectedTreehouse[0]?.timezone,
                age_group: props.selectedTreehouse[0]?.age_group,
                camp_captain_id: props.selectedTreehouse[0]?.captain_details?.id,
            }
            setChallenge(data)
            setLoading(false);
        } else {
            setChallenge({})
            setLoading(false);
        }
    }, [props.selectedTreehouse])

    useEffect(() => {
        if (dependent) {
            if (!dependent?.profile?.group?.id && !isMobile) {
                props.setRightCollapsse("right-collapsse");
            }
            let data = {
                agora_group_id: dependent?.profile?.group?.agora_group_id,
                agora_chat_box: dependent?.profile?.group?.agora_chat_box,
                created_by: {
                    id: dependent?.profile?.group?.id,
                    first_name: dependent?.profile?.group?.group_captain?.first_name,
                    last_name: dependent?.profile?.group?.group_captain?.last_name,
                    picture_url: dependent?.school_details?.tribe_picture ? dependent?.school_details?.tribe_picture : dependent?.school_details?.picture
                },
                treehouse_id: dependent?.profile?.group?.id,
                isCaptain: true
            }
            setChallenge(data)
        }
    }, [])

    useEffect(() => {
        if (isMobile && width < 1200) {
            if (props.leftCollapsse === "left-collapsse") {
                setMobileDisplay('none')
            } else {
                setMobileDisplay('')
            }
        }
    }, [props.leftCollapsse])

    // useEffect(() => {
    //     if(isMobile) {
    //         setCollapseClass("")
    //     } else {

    //     }
    //     (showLayout ? "" : " collapsse")
    // }, [showLayout])

    return (
      <div
        style={{ display: mobileDisplay }}
        className={`flex-col-right ${collapseClass}`}
      >
        <div className="tree-house-chat">
          <div className="tree-house-head">
            <span className={`tree-house-ic ${collapseClass}`}>
              <a
                href="javascript:void(0);"
                className={school ? '' : 'right-dropdown-btn'}
                onClick={setCollapsse}
              >
                {' '}
                {school ? <HiLogout /> : `  `}
              </a>
            </span>
            <span className={`hide-on-toggle `}>Tribe Camp Chat</span>
          </div>
        </div>
        {dependent ? (
          <TribeDependentChat
            selectedTabClass={props.selectedTabClass}
            challenge={challenge}
          />
        ) : challenge?.agora_group_id ? (
          loading ? (
            <Spinner
              key={0}
              className="home-feed-spinner"
              animation="border"
              variant="info"
            />
          ) : (
            <TribeChat challenge={challenge} />
          )
        ) : (
          <div className="chat-area-wrapper hide-on-toggle">
            <span className="lock-ic">
              <BsLockFill />
            </span>
          </div>
        )}
        {!props?.isKidsRoom && dependent && (
          <SideBarAcceptedChallenges {...props} />
        )}
      </div>
    );
}

export default MyRoomRightSideBar;